import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GeocodeService } from 'src/app/services/geocode.service';

@Component({
  selector: 'app-geocode-map',
  templateUrl: './geocode-map.component.html',
  styleUrls: ['./geocode-map.component.scss'],
  providers: [GeocodeService]
})
export class GeocodeMapComponent implements OnChanges {
  @Input() address: any;
  @Input() selectedRegion: any;
  @Input() height: any = '258px';
  @Output() markerClickEvent: EventEmitter<any> = new EventEmitter<any>();

  markersWithCount = [];
  center = {
    lat: 28.081673729044283,
    lng: 1.087646484375
  };
  zoom = 2;
  constructor(private geocodeService: GeocodeService) {

  }
  dispatchEvent(e: any) {
    console.log(e);
    this.center = e.latlng;
    this.zoom = 3;
    this.markerClickEvent.emit(e);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.geocodeAPI();
    this.setCenter();
  }
  setCenter(){
    if(this.selectedRegion){
      this.geocodeService.geocodeAddress(this.selectedRegion)
        .subscribe((location: any) => {        

            this.center=location;
            this.zoom = 3;
          })
    } else {
      this.center = {
        lat: 28.081673729044283,
        lng: 1.087646484375
      };
      this.zoom = 2;
    }
  }
  geocodeAPI() {
    this.address && this.address.map((item: any) => {
      this.geocodeService.geocodeAddress(item.region)
        .subscribe((location: any) => {
          let object = {
            "label": item.region,
            "latlng": location,
            "count": item.count ? item.count.toString(): ''
          }         
          this.markersWithCount.push(object)
        }
        );
    })

    
  }
}
